import FolderItem from '../folderitem';
import {
  DataListHeader,
  DataListHeaderCell,
} from '../ui';

interface FileGridProps {
  folders: Array<any>;
  groups: Array<any>;
  roles: Array<number>;
  view: string;
  refresh: () => void;
  selectFolder: (path: string) => void;
}

const FileGrid = ({
  folders,
  groups,
  roles,
  view,
  refresh,
  selectFolder,
}: FileGridProps) => {
  if (!Array.isArray(folders) || folders.length === 0) {
    return null;
  }

  return (
    <div
      className={`${
        view === 'list'
          ? ' mt-5 mb-10 min-w-[800px] '
          : 'mb-10 mt-5 gap-[2rem]'
      } 
             w-full flex-wrap  items-start relative
              flex `}
    >
      {view === 'list' && (
        <DataListHeader>
          <div className="grid content-center flex-shrink-0 w-[50px]" />
          <DataListHeaderCell className="w-[60px]" />
          <DataListHeaderCell className="flex-grow min-w-[100px]">
            Name
          </DataListHeaderCell>
          {(roles.includes(0) || roles.includes(1)) && (
            <DataListHeaderCell className="w-[150px]">
              Permissions
            </DataListHeaderCell>
          )}
          <DataListHeaderCell className="w-[150px]">Date</DataListHeaderCell>
          <DataListHeaderCell className="w-[120px]">
            File count
          </DataListHeaderCell>
          <DataListHeaderCell className="w-[160px] border-r-0">
            Size
          </DataListHeaderCell>
        </DataListHeader>
      )}
      {folders.map((folder: any) => (
        <FolderItem
          refresh={refresh}
          key={`folder-${folder.ID}`}
          view={view}
          folder={folder}
          selectFolder={selectFolder}
          groups={groups}
        />
      ))}
    </div>
  );
};

export default FileGrid;
